<template>
  <div>
    <div class="main-box p-15-xs">
        <div class="page-title mb_15 mb-10-xs d-flex align-center justify-between">
            <h1 class="d-flex align-center fs-16-xs py-5-xs px-10-xs m-0 fs-18">
                <span class="color-2">Clientes</span>
            </h1>

            <div class="d-flex align-center">
                <p class="badge badge-1 bg-color-3 color-white fw-900 mr_15 fs-12 d-xs-none d-lg-block">{{customers.count}} <span class="fw-400 ml_5">clientes cadastrados na loja</span></p>
                <p v-if="false" @click="search = !search" class="mr_15 m-0-xs cursor-pointer">
                    <i v-show="!this.search" class="fas fa-search color-2 fs-14 mr_5"></i>
                    <span v-show="this.search" class="fs-24 cursor-pointer color-2 mr_5">×</span>
                </p>
            </div>
        </div>

        <!-- <div v-if="false" class="cards-search" :class="{'open': this.search}">
            <div class="box-2 p_15 mb_15 mr_15 mr-0-xs">
                <div class="row">
                    <div class="col-lg-11">
                        <div class="form-group mb_0 mt_5">
                            <label class="m-0 label-input">Busca</label>
                            <input type="search" data-customer-search="" name="" class="form-control" placeholder="Digite um nome, email ou telefone.">
                        </div>
                    </div>

                    <div class="col-lg-1">
                        <button class="w-100 btn_2 btn_sm btn-primary py_10 px_0 mt-15-xs h-100 h-auto-xs cursor-pointer">Filtrar</button>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="mb_15 pr_15 p-0-xs d-block d-lg-none">
            <div class="bg-color-5 w-100 p_15 color-white br-5 card-shadow d-flex align-center justify-center">
                <p class="fs-16 fw-900 mr_5">{{customers.count}}</p> <p>clientes cadastrados na loja</p>
            </div>
        </div>

        <div class="box-2 p_15 mb_15 mr_15 mr-0-xs">
            <div class="form-group with-btn my_5">
                <label class="m-0 label-input">Busca</label>
                <input @keyup.enter="list(searchText)" type="search" data-customer-search="" name="" class="form-control" placeholder="Digite um nome, email ou telefone." v-model="searchText">
                <button @click="list(searchText)" class="btn_2 btn-primary input-btn mobile-btn fs-14"><i class="fas fa-search"></i></button>
            </div>
        </div>

        <!-- Resultados da busca -->
        <div class="row cards px_15 mb_15">
            <div v-for="(customer, i) in customers.customers" :key="i+1" class="col-12 pl_0 pr-0-xs">
                <div v-if="!customer.open" @click="updateCard(i, customer)" class="table-card card-shadow color-4 fs-12 mb_10">
                    <p class="fw-400 color-4 fs-12">{{ customer.name }}</p>
                </div>
                <div v-if="customer.open" class="table-card card-shadow color-4 fs-12">
                    <div class="mb_15">
                        <p class="fw-700 color-2 fs-12">{{ customer.name }}</p>
                    </div>
                    <div class="mb_15">
                        <p class="label">Email</p>
                        <p>{{ customer.email }}</p>
                    </div>

                    <div class="row m_0">
                        <div class="col-6 p_0 mb_15">
                            <p class="label">Telefone</p>
                            <p>{{ Utils.phoneMask(customer.phone) }}</p>
                        </div>
                        <div class="col-6 p_0 mb_15 text-right">
                            <p class="label">Aniversário</p>
                            <p>{{ customer.birthdate ? Utils.db2date(customer.birthdate) : '--' }}</p>
                        </div>
                    </div>

                    <div class="row m_0">
                        <div class="col-4 p_0">
                            <p class="label">Total gasto</p>
                            <p>{{ Utils.convertMoney(customer.total) }}</p>
                        </div>
                        <div class="col-4 p_0 text-center">
                            <p class="label">Pedidos</p>
                            <p>{{ customer.count }}</p>
                        </div>
                        <div class="col-4 p_0 text-right">
                            <p class="label">Ticket médio</p>
                            <p>{{ Utils.convertMoney(customer.total / customer.total || 0) }}</p>
                        </div>
                    </div>
                    <div class="mt_25 text-right">
                        <button v-if="customer.last" @click="drawerOrder(customer.last)" class="btn_2 btn-primary btn_md">Ver último pedido</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Drawer ultimo pedido -->
        <drawer :open="orderDrawer" :title="`Pedido #${targetOrder.order_id}`">
            <orders-detail :report="true" v-if="targetOrder.id" :order="targetOrder"/>
        </drawer>
    </div>
  </div>
</template>

<script>
import Utils from '@/utils'
import CustomerAPI from '@/api/customer'
import OrderAPI from '@/api/order'
import Drawer from "@/components/Drawer"
export default {
  data() {
    return {
      targetOrder: {},
      orderDrawer: false,
      searchText: '',
      Utils,
      search: false,
      customers: {
        count: 0,
        amount: 0,
        customers: []
      }
    }
  },
  created() {
    this.total()
  },
  methods: {
    drawerOrder(order){
        let self = this
        OrderAPI.get(order.id).then((response) => {
            self.targetOrder = response.getData({})
            self.orderDrawer = !self.orderDrawer
        })
    },
    updateCard(iCustomer, oCustomer){
        let self = this
        CustomerAPI.Get(oCustomer.id).then((response) => {
            let data = response.getData({})
            self.customers.customers[iCustomer] = { ...data.order, ...data.user, open: true }
            self.$forceUpdate()
        })
    },
    total () {
      let self = this
      CustomerAPI.Total().then((response) => {
        self.customers.count = response.getPagination({total: 0}).total
      })
    },

    list (search) {
      if(search.length < 4) {
          alert('Mínimo 4 caracteres')
          return false
      }
      let self = this
      CustomerAPI.List(search).then((response) => {
        self.customers.customers = response.getData([])
      })
    },
  },
  components: {
    Drawer
  }
}
</script>